import _styled, { default as _styled2, default as _styled3, default as _styled4, default as _styled5, default as _styled6, default as _styled7, default as _styled8 } from "styled-components";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { useVisibilityObserver } from '@noths/polaris-client-react-hooks';
import { Banner } from "../../elements/Banner/Banner";
import { FloatingBannerImage } from "../../elements/Banner/FloatingBannerImage/FloatingBannerImage";
import * as styles from "./StandardBanner.styles";
export var StandardBanner = function StandardBanner(_ref) {
  var backgroundColor = _ref.backgroundColor,
    copy = _ref.copy,
    heading = _ref.heading,
    imageAlt = _ref.imageAlt,
    imageHeight = _ref.imageHeight,
    imageLinkHref = _ref.imageLinkHref,
    imageWidth = _ref.imageWidth,
    images = _ref.images,
    lazyImages = _ref.lazyImages,
    linkHref = _ref.linkHref,
    linkText = _ref.linkText,
    onImageLinkClick = _ref.onImageLinkClick,
    onLinkClick = _ref.onLinkClick,
    _ref$onVisible = _ref.onVisible,
    onVisible = _ref$onVisible === void 0 ? function () {} : _ref$onVisible;
  var _useVisibilityObserve = useVisibilityObserver(function () {
      return onVisible();
    }),
    observedElementRef = _useVisibilityObserve.observedElementRef;
  var removeImageLinkFromTabIndex = imageLinkHref === linkHref;
  var handleClick = function handleClick(e) {
    onLinkClick === null || onLinkClick === void 0 || onLinkClick(e);
  };
  var Image = function Image() {
    return /*#__PURE__*/React.createElement(FloatingBannerImage, {
      imageAlt: imageAlt,
      imageHeight: imageHeight,
      imageWidth: imageWidth,
      images: images,
      lazyImages: lazyImages,
      offset: "bottom"
    });
  };
  return /*#__PURE__*/React.createElement(_StyledDiv, {
    ref: observedElementRef,
    $_css: styles.bottomOffsetImageMarginContainer
  }, /*#__PURE__*/React.createElement(Banner, {
    backgroundColor: backgroundColor,
    roundedCorners: true
  }, /*#__PURE__*/React.createElement(_StyledDiv2, {
    "data-testid": "standard-banner-content",
    $_css2: styles.container
  }, imageLinkHref ? /*#__PURE__*/React.createElement(_StyledA, _extends({
    href: imageLinkHref,
    onClick: onImageLinkClick
  }, removeImageLinkFromTabIndex ? {
    tabIndex: -1
  } : {}, {
    $_css3: styles.imageWrapper
  }), /*#__PURE__*/React.createElement(Image, null)) : /*#__PURE__*/React.createElement(_StyledDiv3, {
    $_css4: styles.imageWrapper
  }, /*#__PURE__*/React.createElement(Image, null)), /*#__PURE__*/React.createElement(_StyledDiv4, {
    $_css5: styles.content
  }, /*#__PURE__*/React.createElement(_StyledH, {
    $_css6: styles.heading
  }, heading), copy && /*#__PURE__*/React.createElement(_StyledP, {
    $_css7: styles.copy
  }, copy), linkHref && linkText && /*#__PURE__*/React.createElement(_StyledA2, {
    href: linkHref,
    onClick: handleClick,
    $_css8: styles.cta
  }, linkText)))));
};
var _StyledDiv = _styled("div")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css;
});
var _StyledDiv2 = _styled2("div")(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css2;
});
var _StyledA = _styled3("a")(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css3;
});
var _StyledDiv3 = _styled4("div")(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css4;
});
var _StyledDiv4 = _styled5("div")(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css5;
});
var _StyledH = _styled6("h3")(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css6;
});
var _StyledP = _styled7("p")(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css7;
});
var _StyledA2 = /*#__PURE__*/_styled8("a").withConfig({
  displayName: "StandardBanner___StyledA2",
  componentId: "sc-29ot1-0"
})(["", ""], function (p) {
  return p.$_css8;
});